import type { Suggestion } from './types';

export function briefContext(s: Suggestion, exposureId: string): Record<string, string> | null {
  const b = s.brief;
  if (!b) return null;
  return {environment: 'production', experiment_id: b.experiment_id,
    brief_id: b.brief_id, brief_version: b.brief_version,
    evidence_version: b.evidence_version, evidence_state: b.evidence_state,
    variant: b.variant, locale: b.locale, phase: b.phase, freshness: b.freshness,
    exposure_id: exposureId};
}

/** A result can borrow only the evidence actually seen for this card. */
export class BriefExposures {
  private seen = new Map<string, Record<string, string>>();
  view(s: Suggestion, id: string): Record<string, string> | null {
    const ctx = briefContext(s, id);
    if (ctx) this.seen.set(`${s.id}:${s.brief!.evidence_version}:${s.brief!.variant}`, ctx);
    if (this.seen.size > 200) this.seen.delete(this.seen.keys().next().value!);
    return ctx;
  }
  forOutcome(s: Suggestion): Record<string, string> | undefined {
    const ctx = this.seen.get(`${s.id}:${s.brief?.evidence_version}:${s.brief?.variant}`);
    return ctx && s.brief && ctx.evidence_version === s.brief.evidence_version
      && ctx.variant === s.brief.variant ? {...ctx} : undefined;
  }
}

/**
 * The renderer's `onBriefAction`. ⛔ 2026-10-26: not one «Полезно» / «Не помогло»
 * was ever recorded. The peek builds its prev/current/next slides as separate
 * card copies, each with its own exposure id, and the old handler dropped any
 * action whose id was not the LAST viewed one. An action now reports against
 * the card's viewed exposure; a tap with no recorded view is itself proof the
 * card was on screen, so it records the view first.
 */
export function briefActionHandler(tracker: BriefExposures,
    send: (s: Suggestion, meta: Record<string, string>) => void) {
  return (s: Suggestion, action: string, id: string): void => {
    if (action === 'view') {
      const ctx = tracker.view(s, id);
      if (ctx) send(s, {...ctx, action});
      return;
    }
    let ctx = tracker.forOutcome(s);
    if (!ctx) {
      ctx = tracker.view(s, id) ?? undefined;
      if (!ctx) return;
      send(s, {...ctx, action: 'view'});
    }
    send(s, {...ctx, action});
  };
}
